import { Component } from "react";
import PropTypes from "prop-types";

// custom markup
import ListingItem from "../LisingItem";

// markup
import List from "@material-ui/core/List";

export default class History extends Component {
  render() {
    let application = this.props.application;

    let reasons = [];
    if (application.FailReasons && typeof application.FailReasons == "object") {
      reasons = Object.keys(application.FailReasons);
    }

    return (
      <div>
        {reasons.length > 0 ? (
          <List>
            <ListingItem
              primaryText={"Caution adviced"}
              primaryTextStyle={{ color: "red" }}
            />
            {Object.keys(application.FailReasons).map((key, index) => {
              return (
                <ListingItem
                  key={index}
                  secondaryText={key}
                  primaryText={application.FailReasons[key]}
                />
              );
            })}
          </List>
        ) : (
          <p>no failed applications</p>
        )}
      </div>
    );
  }

  static propTypes = {
    application: PropTypes.object,
  };
}
